// src/components/StyledButton.js
import React from 'react';
import { Button, styled } from '@mui/material';


const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  //border: '2px solid black', // Ajout du contour noir
  fontSize:theme.typography.body2.fontSize,
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Ajout de l'ombre légèrement floutée
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
}));

const StyledButton = ({ children, ...props }) => {
  return <CustomButton {...props}>{children}</CustomButton>;
};

export default StyledButton;
